import { useAtomValue } from 'jotai';
import { topMenuPropsAtom } from '../../store/global/atoms/top-menu/top-menu-atoms';

export const useTopMenuValue = () => {
  const topMenuProps = useAtomValue(topMenuPropsAtom);

  return topMenuProps;
};
